export default class HelpIconController {
    /** @ngInject */
    constructor(TranslationService) {
        this.TranslationService = TranslationService;
    }

    $onInit() {
        this.message = this.TranslationService.getLine(this.messageKey);
    }
}



// WEBPACK FOOTER //
// ./app/common/help-icon/help-icon.controller.js